import { render } from "./VZSideDrawer.vue?vue&type=template&id=6baa96a6&ts=true"
import script from "./VZSideDrawer.vue?vue&type=script&lang=ts"
export * from "./VZSideDrawer.vue?vue&type=script&lang=ts"

import "./VZSideDrawer.vue?vue&type=style&index=0&id=6baa96a6&lang=scss"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__